import { ref } from 'vue'

const isIaCardsVisible = ref(false)

export const useIaCardsVisibility = () => {
  const setIaCardsVisibility = (visible: boolean) => {
    isIaCardsVisible.value = visible
  }

  const toggleIaCardsVisibility = () => {
    isIaCardsVisible.value = !isIaCardsVisible.value
  }

  return {
    isIaCardsVisible,
    setIaCardsVisibility,
    toggleIaCardsVisibility,
  }
}
